import { css } from 'linaria';

export const variantImage = css`
  display: block;
  width: var(--space-600);
  height: var(-space-600);
  object-fit: contain;
  overflow: hidden;
`;
